import { Component, useState} from "react";
import { useForm } from "../../../hooks/useForm";
import BaseModal from "../Base-modal";
import Input from "../../../blocks/Input";
import './office-filter-modal.css'
import { useEffect } from "react";
import { useSnackbar } from 'notistack'
import { ajax } from "../../../scripts/helper";
import utils from "../../../scripts/utils";
import context from "../../../scripts/context";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import dayjs, { Dayjs } from 'dayjs';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';







const Content = ({closeModal, showModal, onFilter, onChangeInput}) => {
    const {enqueueSnackbar} = useSnackbar()
    const [statusValue, setStatusValue] = useState()
    const [inputStatusValue, setInputStatusValue] = useState('');
    const [statusOptions, setStatusOptions] = useState([
        {label: 'CREATED' , data: {label: 'CREATED'}},
        {label: 'PAID' ,data: {label: 'PAID'}},
        {label: 'USER_FAILED' ,data: {label: 'USER_FAILED'}},
        {label: 'SERVER_FAILED' ,data: {label: 'SERVER_FAILED'}},
        {label: 'SEND_TO_PGW' ,data: {label: 'SEND_TO_PGW'}},
        {label: 'BLOCKED' ,data: {label: 'BLOCKED'}},
    ])
    const [inputFields, handleChange, setInputFields] = useForm(context.getOfficeInputFilter(),onChangeInput)
    
    const onOfficeInputFilter = (ins) => {
        setInputFields({
            ...ins
        })
    }
    context.addListenerOfficeInputFilter((inputs)=>{onOfficeInputFilter(inputs)})


    const [cityValue, setCityValue] = useState()
    const [inputCityValue, setInputCityValue] = useState('');
    const [cityOptions, setCityOptions] = useState([]);
    const fetchCity = async() => {

        const response = await ajax({
            method: 'GET',
            url: utils.urls.searchCity(inputCityValue),
            hasToken: true,
            snackbar: enqueueSnackbar
        })
        console.log(response)

        if(!response) return

        setCityOptions(response.data)
    }

    useEffect( () => {
        
        if(inputCityValue.trim()) fetchCity()
            
    }, [inputCityValue])

    


    return (
        <div className="inputs-container">
            <div>
                <label>Name</label>
                <div className="field">
                    <Input inputField={inputFields.name}  onChange={handleChange}/>
                </div>
            </div>
            <div>
                <label>code</label>
                <div className="field">
                    <Input inputField={inputFields.code}  onChange={handleChange}/>
                </div>
            </div>
            <div>
                <label>iata</label>
                <div className="field">
                    <Input inputField={inputFields.iata}  onChange={handleChange} />
                </div>
            </div>
            <div>
                <label>city</label>
                <div className="field">
                <Autocomplete 
                    sx={{ width: "100%" }}
                    renderInput={(params) => <TextField {...params} />}
                    getOptionLabel={ (option) =>  option ? option.code : ''}
                    options={cityOptions}
                    autoComplete
                    includeInputInList
                    filterSelectedOptions
                    value={inputFields.city.value}
                    noOptionsText="No city"
                    onChange={(event, newValue) => {
                        setCityValue(newValue?.id);
                        console.log(newValue, ' newvalueeeeeee')
                        setInputFields({
                            ...inputFields,
                            city: {
                                ...inputFields.city,
                                selected: newValue?.id,
                                value: newValue
                            }
                        })
                        onChangeInput({
                            ...inputFields,
                            city: {
                                ...inputFields.city,
                                selected: newValue?.id,
                                value: newValue
                            }
                        })
                        console.log(newValue)
                    }}
                    onInputChange={(event, newInputValue) => {
                        if(newInputValue.trim())
                            setInputCityValue(newInputValue)
                    }}
                    renderOption={(props, option) => <li {...props}>{option.code}</li>}
                />
                </div>
            </div>
        </div>
    )


}

const Footer = ({onFilter, closeModal, inputs}) => {
    // const [input, setInput] = useState(inputs)
    return (
        <div className="btns-container">
            <button className="clear" onClick={ () => {context.clearOfficeInputfilter(); onFilter(context.getOfficeInputFilter());closeModal()}}>Clear Filters</button>
            <button className="cancel" onClick={closeModal} >Cancel</button>
            <button className="apply" onClick={() => {onFilter(inputs);closeModal()}} >Apply Filters</button>
        </div>
    )
}
class OfficeModal extends Component {
    state = {
        open: false,
        inputs: {}
    }

    openModal = () => this.setState({open: true})
    closeModal = () => this.setState({open: false})
    clearDate = () => { return ''}

    onChangeInputs = (inputs) => this.setState({inputs: inputs})

    render() {
        return (
            <BaseModal open={this.state.open} closeModal={this.closeModal} footer={Footer({onFilter: this.props.onFilter,closeModal: this.closeModal, inputs: this.state.inputs})}>
                <Content
                    {...this.props}
                    showModal={this.state.open}
                    closeModal={this.closeModal}
                    onChangeInput={this.onChangeInputs}
                />
            </BaseModal>
        )
    }
}

export default OfficeModal